import { Component, OnInit } from '@angular/core';
import { SavedFilesApi } from '../saved-files.api';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-file-delete',
  templateUrl: './file-delete.component.html',
  styleUrls: ['./file-delete.component.css'],
})

export class FileDeleteComponent implements OnInit {

  constructor(private savedFilesApi: SavedFilesApi, private dialog: MatDialog) {
  }

  ngOnInit() {
  }

  confirmRemoving() {
    this.savedFilesApi.confirmDelete.emit();
  }

}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/saved-files/file-delete/file-delete.component.ts